import { jsx as a } from "react/jsx-runtime";
import { Slot as m } from "@radix-ui/react-slot";
import { cva as s } from "class-variance-authority";
import * as x from "react";
import { cn as p } from "../../utils.js";
const d = s("", {
  variants: {
    variant: {
      largeTitle: "text-largeTitleMobile md:text-largeTitle",
      title1: "text-title1Mobile md:text-title1",
      title2: "text-title2Mobile md:text-title2",
      title3: "text-title3Mobile md:text-title3",
      title4: "text-title4",
      subtitle1: "text-subtitle1Mobile md:text-subtitle1",
      subtitle2: "text-subtitle2Mobile md:text-subtitle2",
      largeBody: "text-largeBody",
      smallBody: "text-smallBody",
      strongSmallBody: "text-strongSmallBody",
      strong: "text-strong",
      body: "text-body",
      button: "text-button",
      preTitle: "text-preTitleMobile uppercase md:text-preTitle"
    }
  },
  defaultVariants: {
    variant: "body"
  }
}), b = x.forwardRef(
  ({ className: t, variant: e = "body", asChild: l = !1, children: o, ...i }, r) => /* @__PURE__ */ a(
    l ? m : "p",
    {
      className: p(d({ variant: e, className: t })),
      ref: r,
      ...i,
      children: o
    }
  )
);
b.displayName = "Typography";
export {
  b as Typography
};
